var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94373 6.57396C4.94373 6.1416 5.11548 5.72695 5.4212 5.42123C5.72692 5.11551 6.14157 4.94376 6.57393 4.94376H11.871C12.3034 4.94376 12.718 5.11551 13.0238 5.42123C13.3295 5.72695 13.5012 6.1416 13.5012 6.57396V11.8711C13.5012 12.0851 13.4591 12.2971 13.3771 12.4949C13.2952 12.6927 13.1751 12.8724 13.0238 13.0238C12.8724 13.1752 12.6927 13.2952 12.4949 13.3772C12.2971 13.4591 12.0851 13.5013 11.871 13.5013H6.57393C6.35985 13.5013 6.14786 13.4591 5.95008 13.3772C5.75229 13.2952 5.57258 13.1752 5.4212 13.0238C5.26982 12.8724 5.14974 12.6927 5.06782 12.4949C4.98589 12.2971 4.94373 12.0851 4.94373 11.8711V6.57396Z",
    stroke: "currentColor",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.11736 10.8955C2.92992 10.7886 2.77401 10.6342 2.66539 10.4477C2.55677 10.2613 2.4993 10.0495 2.49878 9.83375V3.72125C2.49878 3.04887 3.0489 2.49875 3.72128 2.49875H9.83378C10.2922 2.49875 10.5416 2.73408 10.7507 3.11",
    stroke: "currentColor",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3783da0c3e415363802c43db860c9fd1.svg";
export { ForwardRef as ReactComponent };